import { useGetClouderServices } from '../features/common/services';
import { REGIONAL_HUB_SERVICE_KEY } from '../features/routes/utils/routeTypes';

export default function useIsRegionalHubClouder() {
  const {
    data: clouderServices,
    isFetched,
    isFetching,
  } = useGetClouderServices();

  const hasRegionalHubService = clouderServices?.data?.some(
    ({ service_key_name }) => service_key_name === REGIONAL_HUB_SERVICE_KEY
  );

  const isRegionalHubClouder = Boolean(hasRegionalHubService);
  const isLoading = !isFetched || isFetching;

  return { isRegionalHubClouder, isLoading };
}
